import { RootState } from '@modules/App/redux/store';
import { UserEvalPageData } from '@modules/EvaluationModule/interfaces/UserEvalPageData';
import { AsyncData } from '@shared/interfaces/asyncData';

export const userEvalDataSelector = (state: RootState): AsyncData<UserEvalPageData> =>
  state.evaluation.userEvalPage.userEvalData;

export const evaluateeNameSelector = (state: RootState): string | undefined =>
  state.evaluation.evalPage.evalPageData.data?.userHistory.name;
